import {
  CellStyle,
  EditableType,
  InfoBar,
  InterfaceRequirementListPageState,
  RecordSet,
  RequireType,
} from ".";
import { INIT_ERROR_RESULT_DATA } from "../../util";
import { ENV } from "@vrf/fr-vrf-core";
import { IfReqCnclType } from "../../util/general-code/enums/general-codes";

const displayColumn = [
  { label: "Cancel Requirement Type", value: "project.ifReqCnclTypeCd" },
  {
    label: "Source Requirement Type",
    value: "src.interfaceDefinition.interfaceRequirementType",
  },
  {
    label: "Destination Requirement Type",
    value: "dst.interfaceDefinition.interfaceRequirementType",
  },
  {
    label: "Issue Data Kind ID Group Code",
    value: "project.dtKindIdIssueNumGrpCd",
  },
  { label: "Data Kind ID", value: "src.interfaceDefinition.dataKindId" },
  {
    label: "Interface Name (English)",
    value: "src.interfaceDefinition.interfaceNameEnglish",
  },
  {
    label: "Interface Name (Japanese)",
    value: "src.interfaceDefinition.interfaceNameJapanese",
  },
  { label: "Multicast Disabled Flag", value: "project.mltcstDsbldFlg" },
  { label: "Source > DIP", value: "src.interfaceDefinition.dipByRegion" },
  {
    label: "Source > Component ID (From)",
    value: "src.interfaceDefinition.inbound.componentId",
  },
  {
    label: "Source > Interface ID",
    value: "src.interfaceDefinition.interfaceId",
  },
  {
    label: "Source > Inbound ID (Update/Delete/NoChange)",
    value: "project.exgInbdId",
  },
  {
    label: "Source > Inbound ID (Create) > Mandatory Part",
    value: "src.interfaceDefinition.inbound.inboundIdMandatoryPart",
  },
  {
    label: "Source > Inbound ID (Create) > Optional Part",
    value: "src.interfaceDefinition.inbound.inboundIdOptionalPart",
  },
  {
    label: "Source > Partner Type",
    value: "src.interfaceDefinition.inbound.inboundPartner.partnerType",
  },
  {
    label: "Source > Partner Code",
    value: "src.interfaceDefinition.inbound.inboundPartner.partnerCode",
  },
  {
    label: "Source > Business Unit Code",
    value: "src.interfaceDefinition.inbound.inboundPartner.partnerBusiness",
  },
  {
    label:
      "Cross Domain > Src Outbound ID/Dst Inbound ID (Update/Delete/NoChange)",
    value: "src.interfaceDefinition.outbound.outboundId",
  },
  {
    label:
      "Cross Domain > Src Outbound ID/Dst Inbound ID (Create) > Optional Part",
    value: "src.interfaceDefinition.outbound.outboundIdMandatoryPart",
  },
  { label: "Destination > DIP", value: "dst.interfaceDefinition.dipByRegion" },
  {
    label: "Destination > Component ID (To)",
    value: "dst.interfaceDefinition.outbound.componentId",
  },
  {
    label: "Destination > Interface ID",
    value: "dst.interfaceDefinition.interfaceId",
  },
  {
    label: "Destination > Outbound ID (Update/Delete/NoChange)",
    value: "project.exgOtbdId",
  },
  {
    label: "Destination > Outbound ID (Create) > Mandatory Part",
    value: "dst.interfaceDefinition.outbound.outboundIdMandatoryPart",
  },
  {
    label: "Destination > Outbound ID (Create) > Optional Part",
    value: "dst.interfaceDefinition.outbound.outboundIdOptionalPart",
  },
  {
    label: "Destination > Partner Type",
    value: "dst.interfaceDefinition.outbound.outboundPartner.partnerType",
  },
  {
    label: "Destination > Partner Code",
    value: "dst.interfaceDefinition.outbound.outboundPartner.partnerCode",
  },
  {
    label: "Destination > Business Unit Code",
    value: "dst.interfaceDefinition.outbound.outboundPartner.partnerBusiness",
  },
  {
    label: "Schesuled Staging Deploy Date",
    value: "project.stgDplymntPlnDate",
  },
  {
    label: "Scheduled Production Deploy Date",
    value: "project.prdDplymntPlnDate",
  },
  {
    label: "Security Information Level",
    value: "src.interfaceDefinition.inbound.securityInformationLevel",
  },
  {
    label: "Encryption Type for Inbound",
    value:
      "src.interfaceDefinition.inbound.inboundSecurity.inboundEncryptionTypeValue",
  },
  {
    label: "Encryption Type for Outbound",
    value:
      "dst.interfaceDefinition.outbound.outboundSecurity.outboundEncryptionTypeValue",
  },
  {
    label: "IF Cycle",
    value: "src.interfaceDefinition.inbound.inboundMeta.ifCycle",
  },
  {
    label: "IF Cycle Note",
    value: "src.interfaceDefinition.inbound.inboundMeta.ifCycleNote",
  },
  {
    label: "Number of files per a send process",
    value:
      "src.interfaceDefinition.inbound.inboundMeta.numberOfFilesPerASendProcess",
  },
  {
    label: "Density of number of files per a minute",
    value:
      "src.interfaceDefinition.inbound.inboundMeta.densityOfNumberOfFilesPerAMinute",
  },
  {
    label: "Snapshot/Incremental/Delta",
    value:
      "src.interfaceDefinition.inbound.inboundMeta.snapshotIncrementalDelta",
  },
  {
    label: "Source > Division Unit per Inbound ID",
    value:
      "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceId",
  },
  {
    label: "Source > Division Unit per Inbound ID Note",
    value:
      "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceIdNote",
  },
  {
    label: "Source > Data Scope per Inbound file",
    value:
      "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFile",
  },
  {
    label: "Source > Data Scope per Inbound file Note",
    value:
      "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFileNote",
  },
  {
    label: "Source > EDH Inbound > protocol",
    value: "src.interfaceDefinition.inbound.protocol",
  },
  {
    label: "Source > Inbound Talend Job > Use ETL Transceiver",
    value: "src.interfaceDefinition.inbound.useEtlTransceiver",
  },
  {
    label: "Source > Inbound Talend Job > Use Converter",
    value: "src.interfaceDefinition.inbound.useConverter",
  },
  {
    label:
      "Source > Inbound Talend Job > Use Different layouts for Input and Output",
    value:
      "src.interfaceDefinition.inbound.inboundConverter.differentLayoutsForInputAndOutput",
  },
  {
    label: "Source > EDI Inbound > Chain Type",
    value: "src.interfaceDefinition.inbound.inboundPartner.chainTypeCode",
  },
  {
    label: "Source > EDI Inbound > File Type",
    value: "src.interfaceDefinition.inbound.inboundPartner.fileTypeCode",
  },
  {
    label: "Source > EDI Inbound > Polling Adaptor Type",
    value:
      "src.interfaceDefinition.inbound.inboundPartner.pollingAdaptorTypeCode",
  },
  {
    label: "Source > EDI Inbound > Partner IF ID",
    value: "src.interfaceDefinition.inbound.inboundPartner.partnerIfId",
  },
  {
    label: "Destination > Division Unit per Outbound ID",
    value:
      "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceId",
  },
  {
    label: "Destination > Division Unit per Outbound ID Note",
    value:
      "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceIdNote",
  },
  {
    label: "Destination > Data Scope per Outbound file",
    value:
      "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFile",
  },
  {
    label: "Destination > Data Scope per Outbound file Note",
    value:
      "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFileNote",
  },
  {
    label: "Destination > EDH Outbound > EDH protocol",
    value: "dst.interfaceDefinition.outbound.protocol",
  },
  {
    label: "Destination > EDH Outbound > Send DataLake Type",
    value: "dst.interfaceDefinition.outbound.sendDatalakeType",
  },
  {
    label: "Destination > Outbound Talend Job > Use ETL Transceiver",
    value: "dst.interfaceDefinition.outbound.useEtlTransceiver",
  },
  {
    label: "Destination > Outbound Talend Job > Use Converter",
    value: "dst.interfaceDefinition.outbound.useConverter",
  },
  {
    label:
      "Destination > Outbound Talend Job > Different layouts for Input and Output",
    value:
      "dst.interfaceDefinition.outbound.outboundConverter.differentLayoutsForInputAndOutput",
  },
  {
    label: "Destination > EDI Outbound > Chain Type",
    value: "dst.interfaceDefinition.outbound.outboundPartner.chainTypeCode",
  },
  {
    label: "Destination > EDI Outbound > File Type",
    value: "dst.interfaceDefinition.outbound.outboundPartner.fileTypeCode",
  },
  {
    label: "Destination > EDI Outbound > Partner IF ID",
    value: "dst.interfaceDefinition.outbound.outboundPartner.partnerIfId",
  },
];

const infoBarInitialState: InfoBar = {
  isShow: false,
  message: "",
  ready: "",
};

export const InterfaceRequirementListPageInitialState: InterfaceRequirementListPageState =
  {
    dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
    result: {
      total: 0,
      ifList: [],
    },
    dataKind: {
      dataKindList: [],
      fileLayoutList: [],
    },
    ifDefinitionReferenceList: [],
    codes: {
      inDefCommonFlagType: [],
      ptnrType: [],
      ptnrBuCntryType: [],
      interfaceRequirementType: [],
      securityInformationLevelType: [],
      encriptionType: [],
      snapshotIncrementalDeltaType: [],
      ifCycleType: [],
      dataScopeType: [],
      fileTypeType: [],
      ediPollingAdaptorType: [],
      sendDatalakeType: [],
      ifReqCnclType: [],
      dipByRegionList: [],
      inboundEdhProtocolList: [],
      outboundEdhProtocolList: [],
      srcEdiChainTypeList: [],
      dstEdiChainTypeList: [],
    },
    displayColumn: displayColumn,
    status: {
      invalidList: [],
      invalidRecordList: [],
    },
    spreadsheet: {
      tmplateRow: {
        ...INIT_ERROR_RESULT_DATA,
        isAddRow: false,
        cancelledRequirement: false,
        updateFlag: false,
        updateColumn: [],
        projectTcktInfo: {
          srcDsgnTcktId: "",
          srcDsgnTcktStsTypeCd: "",
          srcDsgnWFlwStsDsplyName: "",
          srcDsgnCmnt: "",
          srcDsgnTcktUpdateDateTime: "",
          dstDsgnTcktId: "",
          dstDsgnTcktStsTypeCd: "",
          dstDsgnWFlwStsDsplyName: "",
          dstDsgnCmnt: "",
          dstDsgnTcktUpdateDateTime: "",
          srcStgDplymntTcktId: "",
          srcStgDplymntTcktStsTypeCd: "",
          srcStgDplymntWFlwStsDsplyName: "",
          dstStgDplymntTcktId: "",
          dstStgDplymntTcktStsTypeCd: "",
          dstStgDplymntWFlwStsDsplyName: "",
          srcPrdDplymntTcktId: "",
          srcPrdDplymntTcktStsTypeCd: "",
          srcPrdDplymntWFlwStsDsplyName: "",
          dstPrdDplymntTcktId: "",
          dstPrdDplymntTcktStsTypeCd: "",
          dstPrdDplymntWFlwStsDsplyName: "",
        },
        project: {
          ifReqCnclTypeCd: IfReqCnclType.NORMAL,
          ifReqId: "",
          pjtId: "",
          pjtName: "",
          stgDplymntPlnDate: "",
          prdDplymntPlnDate: "",
          dtKindIdIssueNumGrpCd: "",
          exgInbdId: "",
          exgIntdmnId: "",
          exgOtbdId: "",
          mltcstDsbldFlg: "",
        },
        src: {
          interfaceDefinition: {
            interfaceRequirementType: "",
            interfaceId: "",
            interfaceNameEnglish: "",
            interfaceNameJapanese: "",
            dataKindId: "",
            dipByRegion: "",
            inbound: {
              inboundId: "",
              componentId: "",
              protocol: "",
              securityInformationLevel: "",
              useEtlTransceiver: "",
              useConverter: "",
              inboundConverter: {
                differentLayoutsForInputAndOutput: "",
              },
              inboundPartner: {
                partnerIfId: "",
                partnerCode: "",
                partnerType: "",
                partnerBusiness: "",
                chainTypeCode: "",
                fileTypeCode: "",
                pollingAdaptorTypeCode: "",
              },
              inboundMeta: {
                ifCycle: "",
                ifCycleNote: "",
                snapshotIncrementalDelta: "",
                numberOfFilesPerASendProcess: "",
                densityOfNumberOfFilesPerAMinute: "",
                dataScopePerInterfaceId: "",
                dataScopePerInterfaceIdNote: "",
                dataScopePerInterfaceFile: "",
                dataScopePerInterfaceFileNote: "",
              },
              inboundSecurity: {
                encryptionTypeKey: "",
                encryptionTypeValue: "",
              },
            },
            outbound: {
              outboundId: "",
              componentId: "",
              protocol: "",
              sendDatalakeType: "",
              useEtlTransceiver: "",
              useConverter: "",
              outboundConverter: {
                differentLayoutsForInputAndOutput: "",
              },
              outboundPartner: {
                partnerIfId: "",
                partnerCode: "",
                partnerName: "",
                partnerType: "",
                partnerBusiness: "",
                chainTypeCode: "",
                fileTypeCode: "",
              },
              outboundMeta: {
                dataScopePerInterfaceId: "",
                dataScopePerInterfaceIdNote: "",
                dataScopePerInterfaceFile: "",
                dataScopePerInterfaceFileNote: "",
              },
              outboundSecurity: {
                encryptionTypeKey: "",
                encryptionTypeValue: "",
              },
            },
          },
        },
        dst: {
          interfaceDefinition: {
            interfaceRequirementType: "",
            interfaceId: "",
            interfaceNameEnglish: "",
            interfaceNameJapanese: "",
            dataKindId: "",
            dipByRegion: "",
            inbound: {
              inboundId: "",
              componentId: "",
              protocol: "",
              securityInformationLevel: "",
              useEtlTransceiver: "",
              useConverter: "",
              inboundConverter: {
                differentLayoutsForInputAndOutput: "",
              },
              inboundPartner: {
                partnerIfId: "",
                partnerCode: "",
                partnerType: "",
                partnerBusiness: "",
                chainTypeCode: "",
                fileTypeCode: "",
                pollingAdaptorTypeCode: "",
              },
              inboundMeta: {
                ifCycle: "",
                ifCycleNote: "",
                snapshotIncrementalDelta: "",
                numberOfFilesPerASendProcess: "",
                densityOfNumberOfFilesPerAMinute: "",
                dataScopePerInterfaceId: "",
                dataScopePerInterfaceIdNote: "",
                dataScopePerInterfaceFile: "",
                dataScopePerInterfaceFileNote: "",
              },
              inboundSecurity: {
                encryptionTypeKey: "",
                encryptionTypeValue: "",
              },
            },
            outbound: {
              outboundId: "",
              componentId: "",
              protocol: "",
              sendDatalakeType: "",
              useEtlTransceiver: "",
              useConverter: "",
              outboundConverter: {
                differentLayoutsForInputAndOutput: "",
              },
              outboundPartner: {
                partnerIfId: "",
                partnerCode: "",
                partnerName: "",
                partnerType: "",
                partnerBusiness: "",
                chainTypeCode: "",
                fileTypeCode: "",
              },
              outboundMeta: {
                dataScopePerInterfaceId: "",
                dataScopePerInterfaceIdNote: "",
                dataScopePerInterfaceFile: "",
                dataScopePerInterfaceFileNote: "",
              },
              outboundSecurity: {
                encryptionTypeKey: "",
                encryptionTypeValue: "",
              },
            },
          },
        },
        require: {
          "project.ifReqId": RequireType.NoRequire,
          "project.ifReqCnclTypeCd": RequireType.Mandatory,
          "src.interfaceDefinition.interfaceRequirementType":
            RequireType.Mandatory,
          "dst.interfaceDefinition.interfaceRequirementType":
            RequireType.Mandatory,
          "project.dtKindIdIssueNumGrpCd": RequireType.Optional,
          "src.interfaceDefinition.dataKindId": RequireType.Optional,
          "src.interfaceDefinition.interfaceNameEnglish": RequireType.Mandatory,
          "src.interfaceDefinition.interfaceNameJapanese":
            RequireType.Mandatory,
          "project.mltcstDsbldFlg": RequireType.Mandatory,
          "src.interfaceDefinition.dipByRegion": RequireType.Mandatory,
          "src.interfaceDefinition.inbound.componentId": RequireType.Mandatory,
          "src.interfaceDefinition.interfaceId": RequireType.NoRequire,
          "project.exgInbdId": RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundIdMandatoryPart":
            RequireType.NoRequire,
          "src.interfaceDefinition.inbound.inboundIdOptionalPart":
            RequireType.Optional,
          "src.interfaceDefinition.inbound.inboundPartner.partnerType":
            RequireType.NoRequire,
          "src.interfaceDefinition.inbound.inboundPartner.partnerCode":
            RequireType.Optional,
          "src.interfaceDefinition.inbound.inboundPartner.partnerBusiness":
            RequireType.NoRequire,
          "src.interfaceDefinition.outbound.outboundId": RequireType.NoRequire,
          "src.interfaceDefinition.outbound.outboundIdOptionalPart":
            RequireType.Optional,
          "dst.interfaceDefinition.dipByRegion": RequireType.Mandatory,
          "dst.interfaceDefinition.outbound.componentId": RequireType.Mandatory,
          "dst.interfaceDefinition.interfaceId": RequireType.NoRequire,
          "project.exgOtbdId": RequireType.Mandatory,
          "dst.interfaceDefinition.outbound.outboundIdMandatoryPart":
            RequireType.NoRequire,
          "dst.interfaceDefinition.outbound.outboundIdOptionalPart":
            RequireType.Optional,
          "dst.interfaceDefinition.outbound.outboundPartner.partnerType":
            RequireType.NoRequire,
          "dst.interfaceDefinition.outbound.outboundPartner.partnerCode":
            RequireType.Optional,
          "dst.interfaceDefinition.outbound.outboundPartner.partnerBusiness":
            RequireType.NoRequire,
          "project.stgDplymntPlnDate": RequireType.Mandatory,
          "project.prdDplymntPlnDate": RequireType.Mandatory,
          "src.interfaceDefinition.inbound.securityInformationLevel":
            RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundSecurity.inboundEncryptionTypeValue":
            RequireType.Mandatory,
          "dst.interfaceDefinition.outbound.outboundSecurity.outboundEncryptionTypeValue":
            RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundMeta.ifCycle":
            RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundMeta.ifCycleNote":
            RequireType.Optional,
          "src.interfaceDefinition.inbound.inboundMeta.numberOfFilesPerASendProcess":
            RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundMeta.densityOfNumberOfFilesPerAMinute":
            RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundMeta.snapshotIncrementalDelta":
            RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceId":
            RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceIdNote":
            RequireType.Optional,
          "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFile":
            RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFileNote":
            RequireType.Optional,
          "src.interfaceDefinition.inbound.protocol": RequireType.Mandatory,
          "src.interfaceDefinition.inbound.useEtlTransceiver":
            RequireType.Mandatory,
          "src.interfaceDefinition.inbound.useConverter": RequireType.Mandatory,
          "src.interfaceDefinition.inbound.inboundConverter.differentLayoutsForInputAndOutput":
            RequireType.NoRequire,
          "src.interfaceDefinition.inbound.inboundPartner.chainTypeCode":
            RequireType.NoRequire,
          "src.interfaceDefinition.inbound.inboundPartner.fileTypeCode":
            RequireType.NoRequire,
          "src.interfaceDefinition.inbound.inboundPartner.pollingAdaptorTypeCode":
            RequireType.NoRequire,
          "src.interfaceDefinition.inbound.inboundPartner.partnerIfId":
            RequireType.NoRequire,
          "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceId":
            RequireType.Mandatory,
          "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceIdNote":
            RequireType.Optional,
          "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFile":
            RequireType.Mandatory,
          "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFileNote":
            RequireType.Optional,
          "dst.interfaceDefinition.outbound.protocol": RequireType.Mandatory,
          "dst.interfaceDefinition.outbound.sendDatalakeType":
            RequireType.Mandatory,
          "dst.interfaceDefinition.outbound.useEtlTransceiver":
            RequireType.Mandatory,
          "dst.interfaceDefinition.outbound.useConverter":
            RequireType.Mandatory,
          "dst.interfaceDefinition.outbound.outboundConverter.differentLayoutsForInputAndOutput":
            RequireType.NoRequire,
          "dst.interfaceDefinition.outbound.outboundPartner.chainTypeCode":
            RequireType.NoRequire,
          "dst.interfaceDefinition.outbound.outboundPartner.fileTypeCode":
            RequireType.NoRequire,
          "dst.interfaceDefinition.outbound.outboundPartner.partnerIfId":
            RequireType.NoRequire,
          "dst.interfaceDefinition.outbound.autoRetryFlg":
            RequireType.NoRequire,
          "src.interfaceDefinition.metaOnlyFlag": RequireType.Mandatory,
          "dst.interfaceDefinition.metaOnlyFlag": RequireType.Mandatory,
        },
        editable: {
          "project.ifReqId": EditableType.No,
          "project.ifReqCnclTypeCd": EditableType.Yes,
          "src.interfaceDefinition.interfaceRequirementType": EditableType.Yes,
          "dst.interfaceDefinition.interfaceRequirementType": EditableType.Yes,
          "project.dtKindIdIssueNumGrpCd": EditableType.Yes,
          "src.interfaceDefinition.dataKindId": EditableType.Yes,
          "src.interfaceDefinition.interfaceNameEnglish": EditableType.Yes,
          "src.interfaceDefinition.interfaceNameJapanese": EditableType.Yes,
          "project.mltcstDsbldFlg": EditableType.Yes,
          "src.interfaceDefinition.dipByRegion": EditableType.Yes,
          "src.interfaceDefinition.inbound.componentId": EditableType.Yes,
          "src.interfaceDefinition.interfaceId": EditableType.No,
          "project.exgInbdId": EditableType.No,
          "src.interfaceDefinition.inbound.inboundIdMandatoryPart":
            EditableType.No,
          "src.interfaceDefinition.inbound.inboundIdOptionalPart":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundPartner.partnerType":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundPartner.partnerCode":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundPartner.partnerBusiness":
            EditableType.Yes,
          "src.interfaceDefinition.outbound.outboundId": EditableType.No,
          "src.interfaceDefinition.outbound.outboundIdOptionalPart":
            EditableType.Yes,
          "dst.interfaceDefinition.dipByRegion": EditableType.Yes,
          "dst.interfaceDefinition.outbound.componentId": EditableType.Yes,
          "dst.interfaceDefinition.interfaceId": EditableType.No,
          "project.exgOtbdId": EditableType.No,
          "dst.interfaceDefinition.outbound.outboundIdMandatoryPart":
            EditableType.No,
          "dst.interfaceDefinition.outbound.outboundIdOptionalPart":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundPartner.partnerType":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundPartner.partnerCode":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundPartner.partnerBusiness":
            EditableType.Yes,
          "project.stgDplymntPlnDate": EditableType.Yes,
          "project.prdDplymntPlnDate": EditableType.Yes,
          "src.interfaceDefinition.inbound.securityInformationLevel":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundSecurity.inboundEncryptionTypeValue":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundSecurity.outboundEncryptionTypeValue":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundMeta.ifCycle":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundMeta.ifCycleNote":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundMeta.numberOfFilesPerASendProcess":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundMeta.densityOfNumberOfFilesPerAMinute":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundMeta.snapshotIncrementalDelta":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceId":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceIdNote":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFile":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFileNote":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.protocol": EditableType.Yes,
          "src.interfaceDefinition.inbound.useEtlTransceiver": EditableType.Yes,
          "src.interfaceDefinition.inbound.useConverter": EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundConverter.differentLayoutsForInputAndOutput":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundPartner.chainTypeCode":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundPartner.fileTypeCode":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundPartner.pollingAdaptorTypeCode":
            EditableType.Yes,
          "src.interfaceDefinition.inbound.inboundPartner.partnerIfId":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceId":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceIdNote":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFile":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFileNote":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.protocol": EditableType.Yes,
          "dst.interfaceDefinition.outbound.sendDatalakeType": EditableType.Yes,
          "dst.interfaceDefinition.outbound.useEtlTransceiver":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.useConverter": EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundConverter.differentLayoutsForInputAndOutput":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundPartner.chainTypeCode":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundPartner.fileTypeCode":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.outboundPartner.partnerIfId":
            EditableType.Yes,
          "dst.interfaceDefinition.outbound.autoRetryFlg": EditableType.Yes,
          "src.interfaceDefinition.metaOnlyFlag": EditableType.Yes,
          "dst.interfaceDefinition.metaOnlyFlag": EditableType.Yes,
        },
      },
    },
    infoBar: infoBarInitialState,
    loginUserRoleList: [],
    authorized: false,
  };

export const recordSet: RecordSet = {
  "project.ifReqId": {
    srcDst: "src",
    C: EditableType.No,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "project.ifReqCnclTypeCd": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.Yes,
    U: EditableType.Yes,
    D: EditableType.Yes,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.interfaceRequirementType": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.Yes,
    U: EditableType.Yes,
    D: EditableType.Yes,
    INIT: EditableType.Yes,
  },
  "dst.interfaceDefinition.interfaceRequirementType": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.Yes,
    U: EditableType.Yes,
    D: EditableType.Yes,
    INIT: EditableType.Yes,
  },
  "project.dtKindIdIssueNumGrpCd": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.dataKindId": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.interfaceNameEnglish": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.interfaceNameJapanese": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "project.mltcstDsbldFlg": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.dipByRegion": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.componentId": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.interfaceId": {
    srcDst: "src",
    C: EditableType.No,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "project.exgInbdId": {
    srcDst: "src",
    C: EditableType.No,
    R: EditableType.Yes,
    U: EditableType.Yes,
    D: EditableType.Yes,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundIdMandatoryPart": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundIdOptionalPart": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundPartner.partnerType": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundPartner.partnerCode": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundPartner.partnerBusiness": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.outbound.outboundId": {
    srcDst: "src",
    C: EditableType.No,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.outbound.outboundIdOptionalPart": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.Yes,
    U: EditableType.Yes,
    D: EditableType.Yes,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.securityInformationLevel": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundSecurity.inboundEncryptionTypeValue":
    {
      srcDst: "src",
      C: EditableType.Yes,
      R: EditableType.No,
      U: EditableType.Yes,
      D: EditableType.No,
      INIT: EditableType.No,
    },
  "dst.interfaceDefinition.outbound.outboundSecurity.outboundEncryptionTypeValue":
    {
      srcDst: "dst",
      C: EditableType.Yes,
      R: EditableType.No,
      U: EditableType.Yes,
      D: EditableType.No,
      INIT: EditableType.No,
    },
  "src.interfaceDefinition.inbound.inboundMeta.ifCycle": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundMeta.ifCycleNote": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundMeta.numberOfFilesPerASendProcess": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundMeta.densityOfNumberOfFilesPerAMinute":
    {
      srcDst: "src",
      C: EditableType.Yes,
      R: EditableType.No,
      U: EditableType.Yes,
      D: EditableType.No,
      INIT: EditableType.No,
    },
  "src.interfaceDefinition.inbound.inboundMeta.snapshotIncrementalDelta": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceId": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceIdNote": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFile": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFileNote": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.protocol": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.useEtlTransceiver": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.useConverter": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundConverter.differentLayoutsForInputAndOutput":
    {
      srcDst: "src",
      C: EditableType.Yes,
      R: EditableType.No,
      U: EditableType.Yes,
      D: EditableType.No,
      INIT: EditableType.No,
    },
  "src.interfaceDefinition.inbound.inboundPartner.chainTypeCode": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundPartner.fileTypeCode": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundPartner.pollingAdaptorTypeCode": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.inbound.inboundPartner.partnerIfId": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.dipByRegion": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.componentId": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.interfaceId": {
    srcDst: "dst",
    C: EditableType.No,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "project.exgOtbdId": {
    srcDst: "dst",
    C: EditableType.No,
    R: EditableType.Yes,
    U: EditableType.Yes,
    D: EditableType.Yes,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundIdMandatoryPart": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundIdOptionalPart": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundPartner.partnerType": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundPartner.partnerCode": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundPartner.partnerBusiness": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.No,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "project.stgDplymntPlnDate": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.Yes,
    U: EditableType.Yes,
    D: EditableType.Yes,
    INIT: EditableType.No,
  },
  "project.prdDplymntPlnDate": {
    srcDst: "src",
    C: EditableType.Yes,
    R: EditableType.Yes,
    U: EditableType.Yes,
    D: EditableType.Yes,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceId": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceIdNote": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFile": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFileNote":
    {
      srcDst: "dst",
      C: EditableType.Yes,
      R: EditableType.No,
      U: EditableType.Yes,
      D: EditableType.No,
      INIT: EditableType.No,
    },
  "dst.interfaceDefinition.outbound.protocol": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.sendDatalakeType": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.useEtlTransceiver": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.useConverter": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundConverter.differentLayoutsForInputAndOutput":
    {
      srcDst: "dst",
      C: EditableType.Yes,
      R: EditableType.No,
      U: EditableType.Yes,
      D: EditableType.No,
      INIT: EditableType.No,
    },
  "dst.interfaceDefinition.outbound.outboundPartner.chainTypeCode": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundPartner.fileTypeCode": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.outboundPartner.partnerIfId": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.outbound.autoRetryFlg": {
    srcDst: "dst",
    C: EditableType.Yes,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "src.interfaceDefinition.metaOnlyFlag": {
    srcDst: "src",
    C: EditableType.No,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
  "dst.interfaceDefinition.metaOnlyFlag": {
    srcDst: "dst",
    C: EditableType.No,
    R: EditableType.No,
    U: EditableType.Yes,
    D: EditableType.No,
    INIT: EditableType.No,
  },
};

export const metaOnlyEditableItems: (keyof CellStyle)[] = [
  "dst.interfaceDefinition.dipByRegion",
  "dst.interfaceDefinition.interfaceId",
  "dst.interfaceDefinition.interfaceRequirementType",
  "dst.interfaceDefinition.metaOnlyFlag",
  "dst.interfaceDefinition.outbound.componentId",
  "dst.interfaceDefinition.outbound.outboundConverter.differentLayoutsForInputAndOutput",
  "dst.interfaceDefinition.outbound.outboundIdMandatoryPart",
  "dst.interfaceDefinition.outbound.outboundIdOptionalPart",
  "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFile",
  "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceFileNote",
  "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceId",
  "dst.interfaceDefinition.outbound.outboundMeta.dataScopePerInterfaceIdNote",
  "dst.interfaceDefinition.outbound.outboundSecurity.outboundEncryptionTypeValue",

  "project.dtKindIdIssueNumGrpCd",
  "project.exgInbdId",
  "project.exgOtbdId",
  "project.ifReqCnclTypeCd",
  "project.prdDplymntPlnDate",
  "project.stgDplymntPlnDate",

  "src.interfaceDefinition.dataKindId",
  "src.interfaceDefinition.dipByRegion",
  "src.interfaceDefinition.inbound.componentId",
  "src.interfaceDefinition.inbound.inboundConverter.differentLayoutsForInputAndOutput",
  "src.interfaceDefinition.inbound.inboundIdMandatoryPart",
  "src.interfaceDefinition.inbound.inboundIdOptionalPart",
  "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFile",
  "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceFileNote",
  "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceId",
  "src.interfaceDefinition.inbound.inboundMeta.dataScopePerInterfaceIdNote",
  "src.interfaceDefinition.inbound.inboundMeta.densityOfNumberOfFilesPerAMinute",
  "src.interfaceDefinition.inbound.inboundMeta.ifCycle",
  "src.interfaceDefinition.inbound.inboundMeta.ifCycleNote",
  "src.interfaceDefinition.inbound.inboundMeta.numberOfFilesPerASendProcess",
  "src.interfaceDefinition.inbound.inboundMeta.snapshotIncrementalDelta",
  "src.interfaceDefinition.inbound.inboundPartner.pollingAdaptorTypeCode",
  "src.interfaceDefinition.inbound.inboundSecurity.inboundEncryptionTypeValue",
  "src.interfaceDefinition.inbound.securityInformationLevel",
  "src.interfaceDefinition.interfaceId",
  "src.interfaceDefinition.interfaceRequirementType",
  "src.interfaceDefinition.metaOnlyFlag",
  "src.interfaceDefinition.outbound.outboundId",
];

export const keyIfItems: string[] = [
  "src.interfaceDefinition.interfaceRequirementType",
  "src.interfaceDefinition.metaOnlyFlag",
  "src.interfaceDefinition.dataKindId",
  "src.interfaceDefinition.dipByRegion",
  "src.interfaceDefinition.inbound.componentId",
  "src.interfaceDefinition.interfaceId",

  "src.interfaceDefinition.outbound.outboundId",

  "dst.interfaceDefinition.interfaceRequirementType",
  "dst.interfaceDefinition.metaOnlyFlag",
  "dst.interfaceDefinition.dataKindId",
  "dst.interfaceDefinition.dipByRegion",
  "dst.interfaceDefinition.interfaceId",
  "dst.interfaceDefinition.outbound.componentId",
];
